import React, { useRef } from "react"
import { InputNumber as AntInputNumber, Form } from "antd"
import PropTypes from "prop-types"

import ReadOnlyField from "../ReadOnlyField/ReadOnlyField"

const InputNumber = ({
  size = "middle",
  readOnly,
  defaultValue, // to force value change
  placeholder, // read-only fieldName
  onChange, // returns SyntheticBaseEvent // evt.target.value
  className,
  ellipsis = false,
  label,
  controls = false,
  value,
  labelLayout = "vertical",
  formItemClassName,
  ...moreProps // id, value (controlled), prefi, min, disabledx, style
}) => {
  const inputRef = useRef(null)
  const classNames = ["prime-text-input"]
  if (className) classNames.push(className)
  if (readOnly) classNames.push("read-only")

  // call parent function
  const handleChange = (value) => {
    if (onChange) {
      onChange(value) // value
    }
  }
  const renderInput = () => {
    if (readOnly) {
      let displayValue = ""
      if (value !== null && value !== undefined) displayValue = value
      else if (defaultValue !== null && defaultValue !== undefined) displayValue = defaultValue

      return (
        <ReadOnlyField
          size={size}
          placeholder={placeholder}
          ellipsis={ellipsis}
        >
          {displayValue}
        </ReadOnlyField>
      )
    }

    return (
      <AntInputNumber
        ref={inputRef}
        size={size}
        className={classNames.join(" ")}
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        onChange={handleChange}
        controls={controls}
        {...moreProps}
      />
    )
  }

  if (label) {
    return (
      <Form layout={labelLayout}>
        <Form.Item
          label={label}
          className={`prime-form-item${formItemClassName ? " " + formItemClassName : ""}`}
          colon={false}
          tooltip={moreProps?.tooltip}
        >
          {renderInput(label)}
        </Form.Item>
      </Form>
    )
  }

  return renderInput()
}

InputNumber.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  readOnly: PropTypes.bool,
  defaultValue: PropTypes.number,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  ellipsis: PropTypes.bool,
  controls: PropTypes.bool,
  value: PropTypes.number,
  label: PropTypes.string,
  labelLayout: PropTypes.string,
  formItemClassName: PropTypes.string,
}

export default React.memo(InputNumber)
